import { useEffect } from "react";

/** Several open tabs have to be distinguishable. */
export function usePageTitle(screen: string): void {
  useEffect(() => {
    document.title = screen ? `${screen} · AoB Admin` : "AoB Admin";
  }, [screen]);
}
